<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import {Link} from "@inertiajs/vue3";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import IconCheckMark from "@js/components/Icons/IconCheckMark.vue";
import IconCalculator from "@js/components/Icons/IconCalculator.vue";
import IconDeliveryCar from "@js/components/Icons/IconDeliveryCar.vue";
import IconBox from "@js/components/Icons/IconBox.vue";

export default defineComponent({
    name: "AboutCompanyPage",
    components: {
        IconBox,
        IconDeliveryCar,
        IconCalculator,
        IconCheckMark,
        Link,
        RequisiteTable,
        Breadcrumbs,
        MobileTopBar,
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    },
    data() {
        return {
            categories: [
                'ЖБИ',
                'Бетонные смеси',
                'Пиломатериалы',
                'Тротуарная плитка',
                'Нерудные материалы',
                'Конструкции',
            ],
            directions: [
                {
                    title: 'ЖБИ',
                    text: 'Плиты, блоки, кольца, лотки, элементы колодцев, дорожные и строительные железобетонные изделия.'
                },
                {
                    title: 'Бетон',
                    text: 'Бетонные смеси под фундамент, монолитные работы, дорожное строительство и благоустройство.'
                },
                {
                    title: 'Пиломатериалы',
                    text: 'Доска, брус, брусок, вагонка, погонажные изделия и материалы для строительных задач.'
                },
                {
                    title: 'Благоустройство',
                    text: 'Тротуарная плитка, брусчатка, бордюр, тактильная плитка и сопутствующие материалы.'
                },
                {
                    title: 'Нерудные материалы',
                    text: 'Песок, щебень, гравий и другие сыпучие материалы для подготовки площадок и строительных работ.'
                },
                {
                    title: 'Конструкции',
                    text: 'Строительные конструкции и комплектующие для объектов разного назначения.'
                },
            ]
        }
    }
})
</script>

<template>
    <MobileTopBar/>

    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>

        <section class="relative overflow-hidden rounded-2xl md:rounded-3xl bg-grayBg border border-gray-200 mb-5 md:mb-8">
            <div class="grid lg:grid-cols-[1.05fr_0.95fr] gap-4 md:gap-6 p-4 md:p-8 lg:p-10">
                <div class="relative z-[2]">
                    <div class="inline-flex items-center rounded-full bg-white border border-gray-200 px-3 md:px-4 py-2 text-[11px] md:text-xs font-semibold mb-4 md:mb-5">
                        Оптовые поставки строительных материалов
                    </div>

                    <h1 class="text-2xl md:text-5xl font-bold leading-tight mb-4 md:mb-5">
                        ООО «ФУЛЛ СТРОЙ» - снабжение строительных объектов
                    </h1>

                    <p class="text-sm md:text-base text-gray-700 max-w-2xl mb-5 md:mb-6">
                        Поставляем ЖБИ, бетонные смеси, пиломатериалы, тротуарную плитку, нерудные материалы и
                        строительные конструкции. Помогаем подобрать позиции, рассчитать объем и организовать доставку
                        на объект.
                    </p>

                    <div class="flex flex-wrap gap-2 mb-5 md:mb-6">
                        <span v-for="category in categories"
                              :key="category"
                              class="bg-white border border-gray-200 rounded-full px-3 md:px-4 py-2 text-[11px] md:text-xs font-semibold">
                            {{ category }}
                        </span>
                    </div>

                    <div class="flex flex-wrap gap-3">
                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Оставить заявку
                        </button>

                        <Link :href="route('contacts')"
                              class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-transparent md:hover:bg-baseColor font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Контакты
                        </Link>
                    </div>
                </div>

                <div class="relative min-h-[360px] md:min-h-[360px] rounded-2xl md:rounded-3xl overflow-hidden bg-white border border-gray-200">
                    <img
                        src="@img/backgrounds/about/about-hero.webp"
                        alt="Поставка строительных материалов ФУЛЛ СТРОЙ"
                        class="absolute inset-0 w-full h-full object-cover"
                    >

                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent"></div>

                    <div class="absolute left-3 right-3 bottom-3 md:left-6 md:right-6 md:bottom-6 grid grid-cols-2 gap-2 md:gap-3">
                        <div class="rounded-xl md:rounded-2xl bg-white border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-2xl font-bold leading-tight">Ассортимент</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">Материалы под объект</div>
                        </div>

                        <div class="rounded-xl md:rounded-2xl bg-white border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-2xl font-bold leading-tight">Оптовые цены</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">Выгодные условия</div>
                        </div>

                        <div class="rounded-xl md:rounded-2xl bg-white border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-2xl font-bold leading-tight">Подбор</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">Под задачу клиента</div>
                        </div>

                        <div class="rounded-xl md:rounded-2xl bg-white border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-2xl font-bold leading-tight">Доставка</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">Прямо на объект</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="grid grid-cols-12 gap-4 md:gap-5 mb-5 md:mb-8">
            <div class="col-span-12 lg:col-span-8">
                <div class="bg-white border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 h-full">
                    <h2 class="text-xl md:text-3xl font-bold mb-4 md:mb-5">
                        ФУЛЛ СТРОЙ - это поставщик материалов для стройки
                    </h2>

                    <div class="grid md:grid-cols-2 gap-4 md:gap-5 text-sm md:text-base text-gray-700">
                        <p>
                            Мы работаем с заказчиками, которым важно быстро и понятно закрыть потребность по материалам:
                            подобрать нужные позиции, согласовать объем, получить расчет и организовать поставку.
                        </p>
                        <p>
                            Основной фокус компании - оптовое снабжение строительных объектов. В каталоге собраны
                            материалы для строительства, благоустройства, подготовки площадок и инженерных задач.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-span-12 lg:col-span-4">
                <div class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 h-full">
                    <h3 class="text-lg md:text-xl font-bold mb-4">
                        Что мы закрываем
                    </h3>
                    <ul class="space-y-2.5 text-sm text-gray-700">
                        <li>Подбор материалов под задачу</li>
                        <li>Расчет объема и партии</li>
                        <li>Согласование сроков поставки</li>
                        <li>Доставку на строительный объект</li>
                        <li>Документы и сопровождение заказа</li>
                    </ul>
                </div>
            </div>
        </div>

        <section class="mb-5 md:mb-8">
            <h2 class="text-xl md:text-3xl font-bold mb-4 md:mb-5">
                Почему выбирают нас
            </h2>

            <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
                <!-- 1 -->
                <div class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-5">
                    <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                        <IconBox class="w-5 h-5"/>
                    </div>

                    <h3 class="text-base md:text-lg font-bold mb-2 md:mb-3">
                        Комплексное снабжение
                    </h3>

                    <p class="text-sm text-gray-700">
                        Закрываем основные позиции для строительного объекта в одном месте - от ЖБИ и бетона до пиломатериалов и нерудных материалов.
                    </p>
                </div>

                <!-- 2 -->
                <div class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-5">
                    <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                        <IconDeliveryCar class="w-5 h-5"/>
                    </div>

                    <h3 class="text-base md:text-lg font-bold mb-2 md:mb-3">
                        Поставка на объект
                    </h3>

                    <p class="text-sm text-gray-700">
                        Организуем доставку с учетом объема, графика работ, подъезда к объекту и условий разгрузки.
                    </p>
                </div>

                <!-- 3 -->
                <div class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-5">
                    <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                        <IconCalculator class="w-5 h-5"/>
                    </div>

                    <h3 class="text-base md:text-lg font-bold mb-2 md:mb-3">
                        Работа с объемами
                    </h3>

                    <p class="text-sm text-gray-700">
                        Подбираем материалы под задачу, рассчитываем партии и помогаем согласовать удобный порядок отгрузки.
                    </p>
                </div>

                <!-- 4 -->
                <div class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-5">
                    <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                        <IconCheckMark class="w-5 h-5"/>
                    </div>

                    <h3 class="text-base md:text-lg font-bold mb-2 md:mb-3">
                        Понятные условия
                    </h3>

                    <p class="text-sm text-gray-700">
                        До отгрузки фиксируем позиции, сроки, стоимость и детали доставки, чтобы заказчик понимал итоговые условия.
                    </p>
                </div>
            </div>
        </section>

        <section class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 mb-5 md:mb-8">
            <div class="grid lg:grid-cols-[0.8fr_1.2fr] gap-5 md:gap-6">
                <div>
                    <h2 class="text-xl md:text-3xl font-bold mb-3 md:mb-4">
                        Направления поставок
                    </h2>
                    <p class="text-sm md:text-base text-gray-700">
                        Заказчик может собрать несколько групп материалов в одной заявке и получить расчет по всей
                        поставке.
                    </p>
                </div>

                <div class="grid md:grid-cols-2 gap-3 md:gap-4">
                    <div v-for="direction in directions"
                         :key="direction.title"
                         class="bg-white border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-5">
                        <h3 class="text-base md:text-lg font-bold mb-2">
                            {{ direction.title }}
                        </h3>
                        <p class="text-sm text-gray-700">
                            {{ direction.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="grid grid-cols-12 gap-4 md:gap-5 mb-5 md:mb-8">
            <div class="col-span-12 lg:col-span-8">
                <div class="relative overflow-hidden bg-black text-white rounded-2xl md:rounded-3xl p-4 md:p-8 h-full">
                    <div class="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_80%_20%,rgba(255,186,0,0.8),transparent_35%)]"></div>

                    <div class="relative z-[2]">
                        <h2 class="text-xl md:text-3xl font-bold mb-4 md:mb-5">
                            Наша задача - чтобы материалы приехали тогда, когда они нужны на объекте
                        </h2>

                        <p class="text-sm md:text-base text-white/80 max-w-3xl mb-5 md:mb-6">
                            В строительстве задержка одной позиции может остановить следующий этап работ. Поэтому мы
                            заранее уточняем детали заказа, согласуем логистику и помогаем подобрать удобный формат
                            поставки.
                        </p>

                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full flex justify-center items-center text-center text-black md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Получить расчет
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-span-12 lg:col-span-4">
                <div class="md:sticky md:top-24 border-2 border-baseColor rounded-2xl md:rounded-3xl overflow-hidden">
                    <RequisiteTable/>
                </div>
            </div>
        </section>

        <section class="bg-white border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 mb-5 md:mb-8">
            <h2 class="text-xl md:text-3xl font-bold mb-4 md:mb-6">
                Как строится работа
            </h2>

            <div class="grid md:grid-cols-4 gap-3 md:gap-4">
                <div class="relative bg-grayBg rounded-xl md:rounded-2xl p-4 md:p-5">
                    <div class="text-2xl md:text-3xl font-bold text-baseColor mb-2 md:mb-3">01</div>
                    <h3 class="font-bold mb-2">Заявка</h3>
                    <p class="text-sm text-gray-700">Вы отправляете список материалов или выбираете позиции в каталоге.</p>
                </div>

                <div class="relative bg-grayBg rounded-xl md:rounded-2xl p-4 md:p-5">
                    <div class="text-2xl md:text-3xl font-bold text-baseColor mb-2 md:mb-3">02</div>
                    <h3 class="font-bold mb-2">Расчет</h3>
                    <p class="text-sm text-gray-700">Менеджер уточняет объем, характеристики, сроки и адрес объекта.</p>
                </div>

                <div class="relative bg-grayBg rounded-xl md:rounded-2xl p-4 md:p-5">
                    <div class="text-2xl md:text-3xl font-bold text-baseColor mb-2 md:mb-3">03</div>
                    <h3 class="font-bold mb-2">Согласование</h3>
                    <p class="text-sm text-gray-700">Фиксируем стоимость, условия оплаты, отгрузку и доставку.</p>
                </div>

                <div class="relative bg-grayBg rounded-xl md:rounded-2xl p-4 md:p-5">
                    <div class="text-2xl md:text-3xl font-bold text-baseColor mb-2 md:mb-3">04</div>
                    <h3 class="font-bold mb-2">Поставка</h3>
                    <p class="text-sm text-gray-700">Доставляем материалы на объект или готовим заказ к самовывозу.</p>
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
